var _excluded = ["data"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { loadSDKVersion } from "./util.mjs";
import { configureCache, refreshFeatures, startStreaming, unsubscribe } from "./feature-repository.mjs";
import { decryptPayload, evalFeature as _evalFeature, getAllStickyBucketAssignmentDocs, getApiHosts as _getApiHosts, runExperiment } from "./core.mjs";
var SDK_VERSION = loadSDKVersion();
export var GrowthBookClient = /*#__PURE__*/function () {
  // Properties and methods that start with "_" are mangled by Terser (saves ~150 bytes)

  function GrowthBookClient(options) {
    _classCallCheck(this, GrowthBookClient);
    options = options || {};
    // These properties are all initialized in the constructor instead of above
    // This saves ~80 bytes in the final output
    this.version = SDK_VERSION;
    this._options = options;
    this.debug = !!options.debug;
    this.ready = false;
    this._features = {};
    this._experiments = [];
    this.log = this.log.bind(this);
    if (options.plugins) {
      var _iterator = _createForOfIteratorHelper(options.plugins),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var plugin = _step.value;
          plugin(this);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  return _createClass(GrowthBookClient, [{
    key: "setPayload",
    value: function () {
      var _setPayload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(payload) {
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this._payload = payload;
              _context.n = 1;
              return decryptPayload(payload, this._options.decryptionKey);
            case 1:
              data = _context.v;
              this._decryptedPayload = data;
              if (data.features) {
                this._features = data.features;
              }
              if (data.experiments) {
                this._experiments = data.experiments;
              }
              if (data.savedGroups) {
                this._options.savedGroups = data.savedGroups;
              }
              this.ready = true;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function setPayload(_x) {
        return _setPayload.apply(this, arguments);
      }
      return setPayload;
    }()
  }, {
    key: "initSync",
    value: function initSync(options) {
      var payload = options.payload;
      if (payload.encryptedExperiments || payload.encryptedFeatures) {
        throw new Error("initSync does not support encrypted payloads");
      }
      this._payload = payload;
      this._decryptedPayload = payload;
      if (payload.features) {
        this._features = payload.features;
      }
      if (payload.experiments) {
        this._experiments = payload.experiments;
      }
      this.ready = true;
      startStreaming(this, options);
      return this;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(options) {
        var _yield$this$_refresh, data, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              options = options || {};
              if (options.cacheSettings) {
                configureCache(options.cacheSettings);
              }
              if (!options.payload) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return this.setPayload(options.payload);
            case 1:
              startStreaming(this, options);
              return _context2.a(2, {
                success: true,
                source: "init"
              });
            case 2:
              _context2.n = 3;
              return this._refresh(_objectSpread(_objectSpread({}, options), {}, {
                allowStale: true
              }));
            case 3:
              _yield$this$_refresh = _context2.v;
              data = _yield$this$_refresh.data;
              res = _objectWithoutProperties(_yield$this$_refresh, _excluded);
              startStreaming(this, options);
              _context2.n = 4;
              return this.setPayload(data || {});
            case 4:
              return _context2.a(2, res);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function init(_x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "refreshFeatures",
    value: function () {
      var _refreshFeatures = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(options) {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this._refresh(_objectSpread(_objectSpread({}, options || {}), {}, {
                allowStale: false
              }));
            case 1:
              res = _context3.v;
              if (!res.data) {
                _context3.n = 2;
                break;
              }
              _context3.n = 2;
              return this.setPayload(res.data);
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function refreshFeatures(_x3) {
        return _refreshFeatures.apply(this, arguments);
      }
      return refreshFeatures;
    }()
  }, {
    key: "getApiInfo",
    value: function getApiInfo() {
      return [this.getApiHosts().apiHost, this.getClientKey()];
    }
  }, {
    key: "getApiHosts",
    value: function getApiHosts() {
      return _getApiHosts(this._options);
    }
  }, {
    key: "getClientKey",
    value: function getClientKey() {
      return this._options.clientKey || "";
    }
  }, {
    key: "getPayload",
    value: function getPayload() {
      return this._payload || {
        features: this.getFeatures(),
        experiments: this._experiments || []
      };
    }
  }, {
    key: "getDecryptedPayload",
    value: function getDecryptedPayload() {
      return this._decryptedPayload || this.getPayload();
    }
  }, {
    key: "_refresh",
    value: function () {
      var _refresh2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref) {
        var timeout, skipCache, allowStale, streaming;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              timeout = _ref.timeout, skipCache = _ref.skipCache, allowStale = _ref.allowStale, streaming = _ref.streaming;
              if (this._options.clientKey) {
                _context4.n = 1;
                break;
              }
              throw new Error("Missing clientKey");
            case 1:
              return _context4.a(2, refreshFeatures({
                instance: this,
                timeout: timeout,
                skipCache: skipCache || this._options.disableCache,
                allowStale: allowStale,
                backgroundSync: streaming !== null && streaming !== void 0 ? streaming : true
              }));
          }
        }, _callee4, this);
      }));
      function _refresh(_x4) {
        return _refresh2.apply(this, arguments);
      }
      return _refresh;
    }()
  }, {
    key: "getFeatures",
    value: function getFeatures() {
      return this._features || {};
    }
  }, {
    key: "getGlobalAttributes",
    value: function getGlobalAttributes() {
      return this._options.globalAttributes || {};
    }
  }, {
    key: "setGlobalAttributes",
    value: function setGlobalAttributes(attributes) {
      this._options.globalAttributes = attributes;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._destroyed = true;
      unsubscribe(this);

      // Release references to save memory
      this._features = {};
      this._experiments = [];
      this._decryptedPayload = undefined;
      this._payload = undefined;
      this._options = {};
    }
  }, {
    key: "isDestroyed",
    value: function isDestroyed() {
      return !!this._destroyed;
    }
  }, {
    key: "setEventLogger",
    value: function setEventLogger(logger) {
      this._options.eventLogger = logger;
    }
  }, {
    key: "logEvent",
    value: function logEvent(eventName, properties, userContext) {
      if (this._options.eventLogger) {
        var ctx = this._getEvalContext(userContext);
        this._options.eventLogger(eventName, properties, ctx.user);
      }
    }
  }, {
    key: "runInlineExperiment",
    value: function runInlineExperiment(experiment, userContext) {
      var _runExperiment = runExperiment(experiment, null, this._getEvalContext(userContext)),
        result = _runExperiment.result;
      return result;
    }
  }, {
    key: "_getEvalContext",
    value: function _getEvalContext(userContext) {
      if (this._options.globalAttributes) {
        userContext = _objectSpread(_objectSpread({}, userContext), {}, {
          attributes: _objectSpread(_objectSpread({}, this._options.globalAttributes), userContext.attributes)
        });
      }
      return {
        user: userContext,
        global: this._getGlobalContext(),
        stack: {
          evaluatedFeatures: new Set()
        }
      };
    }
  }, {
    key: "_getGlobalContext",
    value: function _getGlobalContext() {
      return {
        features: this._features,
        experiments: this._experiments,
        log: this.log,
        enabled: this._options.enabled,
        qaMode: this._options.qaMode,
        savedGroups: this._options.savedGroups,
        forcedFeatureValues: this._options.forcedFeatureValues,
        forcedVariations: this._options.forcedVariations,
        trackingCallback: this._options.trackingCallback,
        onFeatureUsage: this._options.onFeatureUsage
      };
    }
  }, {
    key: "isOn",
    value: function isOn(key, userContext) {
      return this.evalFeature(key, userContext).on;
    }
  }, {
    key: "isOff",
    value: function isOff(key, userContext) {
      return this.evalFeature(key, userContext).off;
    }
  }, {
    key: "getFeatureValue",
    value: function getFeatureValue(key, defaultValue, userContext) {
      var value = this.evalFeature(key, userContext).value;
      return value === null ? defaultValue : value;
    }
  }, {
    key: "evalFeature",
    value: function evalFeature(id, userContext) {
      return _evalFeature(id, this._getEvalContext(userContext));
    }
  }, {
    key: "log",
    value: function log(msg, ctx) {
      if (!this.debug) return;
      if (this._options.log) this._options.log(msg, ctx);else console.log(msg, ctx);
    }
  }, {
    key: "setTrackingCallback",
    value: function setTrackingCallback(callback) {
      this._options.trackingCallback = callback;
    }
  }, {
    key: "applyStickyBuckets",
    value: function () {
      var _applyStickyBuckets = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(partialContext, stickyBucketService) {
        var ctx, stickyBucketAssignmentDocs;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              ctx = this._getEvalContext(partialContext);
              _context5.n = 1;
              return getAllStickyBucketAssignmentDocs(ctx, stickyBucketService);
            case 1:
              stickyBucketAssignmentDocs = _context5.v;
              return _context5.a(2, _objectSpread(_objectSpread({}, partialContext), {}, {
                stickyBucketAssignmentDocs: stickyBucketAssignmentDocs,
                saveStickyBucketAssignmentDoc: function saveStickyBucketAssignmentDoc(doc) {
                  return stickyBucketService.saveAssignments(doc);
                }
              }));
          }
        }, _callee5, this);
      }));
      function applyStickyBuckets(_x5, _x6) {
        return _applyStickyBuckets.apply(this, arguments);
      }
      return applyStickyBuckets;
    }()
  }, {
    key: "createScopedInstance",
    value: function createScopedInstance(userContext, userPlugins) {
      return new UserScopedGrowthBook(this, userContext, [].concat(_toConsumableArray(this._options.plugins || []), _toConsumableArray(userPlugins || [])));
    }
  }]);
}();
export var UserScopedGrowthBook = /*#__PURE__*/function () {
  function UserScopedGrowthBook(gb, userContext, plugins) {
    _classCallCheck(this, UserScopedGrowthBook);
    this._gb = gb;
    this._userContext = userContext;
    this.logs = [];
    this._userContext.trackedExperiments = this._userContext.trackedExperiments || new Set();
    this._userContext.trackedFeatureUsage = this._userContext.trackedFeatureUsage || {};
    this._userContext.devLogs = this.logs;
    if (plugins) {
      var _iterator2 = _createForOfIteratorHelper(plugins),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var plugin = _step2.value;
          plugin(this);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }
  return _createClass(UserScopedGrowthBook, [{
    key: "runInlineExperiment",
    value: function runInlineExperiment(experiment) {
      return this._gb.runInlineExperiment(experiment, this._userContext);
    }
  }, {
    key: "isOn",
    value: function isOn(key) {
      return this._gb.isOn(key, this._userContext);
    }
  }, {
    key: "isOff",
    value: function isOff(key) {
      return this._gb.isOff(key, this._userContext);
    }
  }, {
    key: "getFeatureValue",
    value: function getFeatureValue(key, defaultValue) {
      return this._gb.getFeatureValue(key, defaultValue, this._userContext);
    }
  }, {
    key: "evalFeature",
    value: function evalFeature(id) {
      return this._gb.evalFeature(id, this._userContext);
    }
  }, {
    key: "logEvent",
    value: function logEvent(eventName, properties) {
      if (this._userContext.enableDevMode) {
        this.logs.push({
          eventName: eventName,
          properties: properties,
          timestamp: Date.now().toString(),
          logType: "event"
        });
      }
      this._gb.logEvent(eventName, properties || {}, this._userContext);
    }
  }, {
    key: "setTrackingCallback",
    value: function setTrackingCallback(cb) {
      this._userContext.trackingCallback = cb;
    }
  }, {
    key: "getApiInfo",
    value: function getApiInfo() {
      return this._gb.getApiInfo();
    }
  }, {
    key: "getClientKey",
    value: function getClientKey() {
      return this._gb.getClientKey();
    }
  }, {
    key: "setURL",
    value: function setURL(url) {
      this._userContext.url = url;
    }
  }, {
    key: "updateAttributes",
    value: function updateAttributes(attributes) {
      this._userContext.attributes = _objectSpread(_objectSpread({}, this._userContext.attributes), attributes);
    }
  }, {
    key: "setAttributeOverrides",
    value: function setAttributeOverrides(overrides) {
      this._userContext.attributeOverrides = overrides;
    }
  }, {
    key: "setForcedVariations",
    value: function () {
      var _setForcedVariations = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(vars) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              this._userContext.forcedVariations = vars || {};
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function setForcedVariations(_x7) {
        return _setForcedVariations.apply(this, arguments);
      }
      return setForcedVariations;
    }() // eslint-disable-next-line
  }, {
    key: "setForcedFeatures",
    value: function setForcedFeatures(map) {
      this._userContext.forcedFeatureValues = map;
    }
  }, {
    key: "getUserContext",
    value: function getUserContext() {
      return this._userContext;
    }
  }, {
    key: "getVersion",
    value: function getVersion() {
      return SDK_VERSION;
    }
  }, {
    key: "getDecryptedPayload",
    value: function getDecryptedPayload() {
      return this._gb.getDecryptedPayload();
    }
  }, {
    key: "inDevMode",
    value: function inDevMode() {
      return !!this._userContext.enableDevMode;
    }
  }]);
}();